import React from "react";

import classNames from "classnames/bind";

import styles from "./QuickFilters.module.scss";

import { QuickFilter } from "./QuickFilter";

import { QuickFiltersProps } from "./types";

const cx = classNames.bind(styles);

/**
 * @deprecated
 */
const QuickFilters = ({
  items,
  loading,
  onChange,
  value = [],
}: QuickFiltersProps) => {
  return (
    <div className={cx("container")}>
      {items?.map(
        ({ onClick, value: quickFilterValue, ...itemProps }, index) => (
          <QuickFilter
            key={index}
            {...itemProps}
            onClick={() => {
              const selected = value.find(
                (current) => current === quickFilterValue
              );

              if (onChange) {
                if (selected) {
                  onChange(
                    value.filter((current) => current !== quickFilterValue)
                  );
                } else {
                  if (quickFilterValue) {
                    onChange([...value, quickFilterValue]);
                  } else {
                    onChange([]);
                  }
                }
              }

              if (onClick) {
                onClick(quickFilterValue);
              }
            }}
            active={
              (!quickFilterValue && value?.length === 0) ||
              value.find((current) => current === quickFilterValue)
                ? true
                : false
            }
            loading={loading}
          />
        )
      )}
    </div>
  );
};

export default QuickFilters;
